import React, {FC, useCallback} from "react";
import styles from './TablePaymentSelect.module.scss';
import {PaymentCardItem} from "../../../components/paymentCardItem/PaymentCardItem";
import {useTablePayment} from "../../../context/tablePayment/TablePaymentContext";
import {PaymentType} from "../../../models/payment/IPay";

export const TablePaymentSelect: FC = () => {
    const {
        totalAmountToPay,
        paymentType,
        updatePaymentMethod,
        onSubmitProducts
    } = useTablePayment();

    const setPaymentStripe = useCallback(async () => {
        await onSubmitProducts();
        updatePaymentMethod(PaymentType.STRIPE);
    },[onSubmitProducts]);

    return (<>
        <div className={styles.container}>
            <div className={styles.title}>Pagamento</div>
            <hr/>
            <div className={styles.cardItemsContent}>
                <PaymentCardItem
                    onClick={() => updatePaymentMethod(PaymentType.PIX)}
                    disabled={!totalAmountToPay}
                    selected={paymentType === PaymentType.PIX}
                    iconName={'pix'}
                    imageSize={{width: 24, height: 24}}
                    textTop={'PIX'}/>
                <PaymentCardItem
                    onClick={() => updatePaymentMethod(PaymentType.CREDITO)}
                    disabled={!totalAmountToPay}
                    selected={paymentType === PaymentType.CREDITO}
                    iconName={'credit_card'}
                    textTop={'Cartão de Crédito'}/>
                <PaymentCardItem
                    onClick={setPaymentStripe}
                    disabled={!totalAmountToPay || totalAmountToPay < 1.00}
                    selected={paymentType === PaymentType.STRIPE}
                    iconName={'contactless'}
                    textTop={'Apple Pay/Google Pay'}/>
            </div>
        </div>
    </>);
};
